import { render, staticRenderFns } from "./unruly-goods.vue?vue&type=template&id=d22483dc"
import script from "./unruly-goods.vue?vue&type=script&lang=js"
export * from "./unruly-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports